import React from "react";
import Button from "components/Form/fields/Button";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import {
  getConsent,
  ACCEPT_CONSENT,
  REJECT_CONSENT,
  setConsent
} from "utils/consent";
import isEmpty from "lodash/isEmpty";
import { postConsentActions } from "utils/consent";
import PATHS from "utils/paths";
import Link from "next/link";

const CookieConsent = () => {
  const consent = getConsent();
  /**
   * If there is a consent value then it's considered answered
   * - hasConsent will then be either true / false
   * - but once answered we can hide the component
   */
  if (consent && consent.hasOwnProperty("hasConsent")) {
    return null;
  }

  const confirmConsent = () => {
    postConsentActions();

    setConsent(ACCEPT_CONSENT);
  };

  const rejectConsent = () => {
    setConsent(REJECT_CONSENT);
  };

  const actionProps = [
    {
      copy: `Reject`,
      onClick: rejectConsent,
      classes: {
        button:
          "fw6 br2 ph3 pv2 border-box input-reset f6 dib link items-center flex bn pointer",
        contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
      }
    },
    {
      copy: `Accept`,
      onClick: confirmConsent
    }
  ];

  return (
    <div className="w-100">
      {isEmpty(consent) && (
        <div className="w-100 fixed bottom-0 left-0 right-0 hairline-1 bt bg-white flex flex-row items-center ph3 z-max pv3">
          <div className="flex w-100">
            <div className="f6 f5-ns pr2">
              We use cookies to ensure you get the best experience on our
              website.{" "}
              <span>
                <Link href={PATHS.COOKIE_POLICY}>
                  <a className="link__decoration--hover color-primary link">
                    See cookie policy
                  </a>
                </Link>
              </span>
            </div>
          </div>
          <div className="flex flex-row">
            {actionProps.map((action, actionIx) => (
              <div key={actionIx} className={actionIx ? "ml2" : ""}>
                <Button key={actionIx} {...action} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieConsent;
